<template>
  <el-form :model="form" :rules="rules" ref="form" label-position="top" class="category-attr">
    <template v-if="product_attr_list.length && !formVoid">
      <template v-for="(item) in product_attr_list">
         <div
          class="attr-item"
          :key="item.name">
          <el-form-item
            :prop="`${item.name}`"
            :label="item.name"
            :rules="[{required: item.isRequired, message:'请输入'+item.name }]"
            style="flex-direction:column">
            <el-select
              v-if="item.type === 'select_one'"
              filterable
              clearable
              :allow-create="item.customizable"
              :multiple="item.isMulti"
              :multiple-limit="3"
              @change="selectChange(item)"
              v-model="form[item.name]">
              <el-option
                v-for="(op) in item.values"
                :key="op.valueId"
                :label="op.valueName"
                :value="`${op.valueName}`"
              ></el-option>
            </el-select>
            <el-input v-else v-model="form[item.name]" clearable @change="selectChange(item)"></el-input>
          </el-form-item>
        </div>
      </template>
    </template>
    <div v-else>暂无属性</div>
    <template v-if="cid">
      <span class="update-brand">找不到商品属性？
          <el-link :underline="false" @click="fetch_props(true)">刷新数据</el-link>
      </span>
    </template>
    <!-- <div>{{product_attr_list}}</div> -->
  </el-form>
</template>

<script>
import { getCategoryProps } from '@/servers/prod/center/xhs.js'
import { mapActions } from 'vuex'

export default {
  model: {
    prop: 'values',
    event: 'change'
  },
  props: {
    values: {
      required: true
    },
    categoryIds: {
      type: Array,
      default() {
        return []
      }
    },
    attributeLis: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      form: {},
      formVoid: true,
      product_attr_list: [],
      rules: {},
      categoryIdChange: false,
      categoryId: '',
      cid: '',
      localValueSyncing: false,
    }
  },
  watch: {
    categoryIds: {
      handler(v) {
        this.categoryId = !v.length ? '' : v[v.length - 1]
      },
      immediate: true
    },
    categoryId: {
      handler(v, o) {
        this.product_attr_list = []
        this.rules = {}
        this.categoryIdChange = !!o
        this.cid = v;
        v && this.fetch_props()
      },
      immediate: true
    },
    values: {
      immediate: true,
      handler(v) {
        if (this.localValueSyncing) return;
        if (!this.product_attr_list.length) return ;
        if (!v || !v.length) {
            this.form = {}
            this.formVoid = true
            return;
        }
        this.formVoid = false;
        v.forEach(item => {
          let isMulti = this.product_attr_list.find(li => li.id == item.propertyId)?.isMulti || false;
          if (isMulti) {
            let values = item.valueList?.map(i=>i.value)
            this.$set(this.form, item.name, values); // 多选数组
          }else{
            this.$set(this.form, item.name, item.value); // 单选值
          }
        })
      }
    }
  },
  methods: {
    ...mapActions(['updateCatePropShopIndex']),
    async fetch_props(isUpdate) {
        isUpdate && this.updateCatePropShopIndex("xhs")
        const propConfigs = await getCategoryProps({leafCategoryId: this.cid});
        this.product_attr_list = propConfigs;
        this.initValues(propConfigs)
    },
    // 初始化类目属性数据结构
    initValues(propConfigs) {
      
      let init_values = [];
      propConfigs.forEach(item => {
        let v = {
          propertyId: item.id,
          name: item.name
        }
        let oldValue = this.values && this.values.find(v => `${v.name}` === `${item.name}`)
        if (oldValue && !this.categoryIdChange) {
          // 老值回显问题
          init_values.push(oldValue)
        } else {
          init_values.push(v)
        }
        this.setRulesByPropConfig(item)
      })
      this.syncValues(init_values)
      this.categoryIdChange = false
    },

    selectChange(item) {
      const changedValue = this.formatAttributeValue(item);
      const values = Array.isArray(this.values) ? this.values.slice() : [];
      const valueIndex = values.findIndex(value => {
        return String(value.propertyId) === String(item.id) || String(value.name) === String(item.name);
      });
      if (valueIndex > -1) {
        values.splice(valueIndex, 1, changedValue);
      } else {
        values.push(changedValue);
      }
      this.localValueSyncing = true;
      this.syncValues(values);
      this.$nextTick(() => {
        this.localValueSyncing = false;
      });
    },
    formatAttributeValue(item) {
      const params = {
        propertyId: item.id,
        name: item.name,
      };
      const formValue = this.form[item.name];
      if (item.isMulti && Array.isArray(formValue) && formValue.length) {
        const valueList = formValue.map(value => {
          const option = (item.values || []).find(option => option.valueName === value);
          if (option) return { valueId: option.valueId, value: option.valueName };
          return item.customizable ? { value } : null;
        }).filter(Boolean);
        if (valueList.length) params.valueList = valueList;
      } else if (formValue !== '' && formValue !== null && formValue !== undefined) {
        const option = (item.values || []).find(option => option.valueName === formValue);
        if (option) {
          params.value = option.valueName;
          params.valueId = option.valueId;
        } else if (item.customizable) {
          params.value = formValue;
        }
      }
      return params;
    },
    syncValues(values) {
      this.$emit('change', values)
    },
    setRulesByPropConfig(config) {
      let rules = []
      if (config.isRequired === 'true') {
        rules.push({ required: true, message: `请完善${config.name}` })
        rules.push({ validator: (rule, value, cb) => {
          if (value) {
            cb()
          } else {
            cb(new Error(`请完善${config.name}`))
          }
        } })
      }
      this.$set(this.rules, config.name, rules)
    },
    validate() {
      return new Promise((resolve) => {
          this.$refs.form.validate(valid => {
              resolve(valid);
          })
      })
    },
  }
  
}
</script>

<style lang="scss" scoped>
.category-attr {
  align-items: flex-start;
  position: relative;
  
  .attr-item {
    margin-bottom: 10px !important;
    .red{
      color:#F56C6C;
      margin-right: 4px;
    }
    ::v-deep .el-form-item__content{
      display: flex;
    }
  }

  ::v-deep .el-form-item__label {
    padding: 0;
  }
  .update-brand {
    position: absolute;
    left: 20px;
    bottom: 0px;
    font-size: 12px;
  }
}
</style>
